import type { FormInstance, FormProps } from 'antd'
import { Col, Form, Row } from 'antd'
import { rendererMap } from '.'
import type { SchemaType } from '../schemas'
import { formSchema } from '../schemas'
import { setStoreData } from '../stores'
import { withParsedData } from './base'

export const FormRenderer = withParsedData(formSchema)<{
  form?: FormInstance
  externalStoreId?: string
}>(({ parsedData, form, externalStoreId }) => {
  const [formInstance] = Form.useForm()
  const _from = form || formInstance
  const { storeId, fields, labelWidth, gutter, ...rest } = parsedData
  // query-list 调用此组件是，storeId 为空，需要从外部传入
  const _storeId = storeId || externalStoreId

  const children = fields?.map((item, index) => {
    const { type, span } = item
    const RendererComponent = rendererMap[type as SchemaType]

    if (RendererComponent) {
      const key = `${type}${index}`
      return (
        <Col span={span} key={key}>
          <RendererComponent data={item} />
        </Col>
      )
    }

    return null
  })

  const labelCol = typeof labelWidth === 'number' ? { span: labelWidth } : { flex: labelWidth }

  const onValuesChange: FormProps['onValuesChange'] = (_, values) => {
    if (_storeId) {
      setStoreData(_storeId, values)
    }
  }

  return (
    <Form {...rest} form={_from} labelCol={labelCol} onValuesChange={onValuesChange}>
      <Row gutter={gutter}>{children}</Row>
    </Form>
  )
})
